import _get from 'lodash/get';
import getConfig from 'next/config';

import { format, removeSpecialCharacter } from '../utils';

import Service from './service';

// TODO Move to constants
const getCompaniesByIds = '/api/getCompaniesByIds';
const getCompanyDataById = '/api/getCompanyDataById';
// TODO: Move to constants

const {
  publicRuntimeConfig: { HttpRoutes },
} = getConfig();

const CommonService = {
  normalizedData(payload) {
    let url = HttpRoutes.getNormalizedData;
    if (payload.major) {
      url = HttpRoutes.getNormalizedMajorData;
    }
    return Service.post(url, payload)
      .then((response) => response)
      .catch((error) => error);
  },

  getCompanyInfoByIds(companyIds) {
    const payload = {
      companyIds,
    };
    return Service.post(getCompaniesByIds, payload)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          return response.data[0];
        }
        return Promise.reject();
      })
      .catch((error) => Promise.reject(error));
  },

  getCititesByState(data) {
    return Service.get(format(HttpRoutes.getCititesByState, data))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  analyticsToLog(data) {
    const payload = {
      data,
    };
    return Service.post(HttpRoutes.analyticsToLog, payload)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getCompanyDataById(companyId) {
    const payload = {
      companyId,
    };
    return Service.post(getCompanyDataById, payload)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => Promise.reject(error));
  },

  getCompanyDemographicsDataById(data) {
    return Service.get(format(HttpRoutes.getCompanyDemographicsDataById, data))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalariesByLocation(data) {
    return Service.post(HttpRoutes.salaryDataByTitleSalaryPagebyLocation, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalariesByMajor(data) {
    return Service.post(HttpRoutes.salaryByLocationMajorSalaryPage, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchSalariesByMajorAndCompany(data) {
    return Service.post(HttpRoutes.getSalariesByMajorAndCompany, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchSalariesByTitleAndCompany(data) {
    return Service.post(HttpRoutes.salaryDataByTitleSalaryPagebyCompany, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalariesByCompany(data) {
    return Service.post(HttpRoutes.getSalaryDataByCompany, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalariesByJobTitle(data, sliceParams = true) {
    data.param = sliceParams ? data.param.slice(0, 10) : data.param;
    return Service.post(HttpRoutes.salaryDataByTitleSalaryPageByJobTitle, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchCompanySalariesByCompany(data) {
    data.locations = data.locations.slice(0, 3);
    return Service.post(HttpRoutes.fetchCompanySalariesByCompany, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchCompanyPoliticalDonators(data) {
    return Service.get(format(HttpRoutes.getCompanyDonators, data))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchJobTitleRecentSalaries(data) {
    return Service.post(HttpRoutes.fetchJobTitleRecentSalaries, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalaryHistoryDataByLocation(data) {
    return Service.post(HttpRoutes.getSalaryHistoryChartData, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchTopSalaryData(data) {
    return Service.get(format(HttpRoutes.salaryData, data))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchSalaryDataByTitleAndLocation(data) {
    return Service.get(format(HttpRoutes.salaryDataByTitleAndLocation, data))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.resolve({ topSalaryData: [] });
      });
  },

  fetchNextPrevReviewForCompany(data) {
    return Service.post(HttpRoutes.getNextPrevReviewForCompany, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  moderateReview(data) {
    return Service.post(HttpRoutes.moderateReview, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchNextPrevReviewForJobTitle(data) {
    return Service.post(HttpRoutes.getNextPrevReviewForJobTitle, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getProfileSummary(data) {
    return Service.get(format(HttpRoutes.getProfileSummary, { title: data }))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  fetchTopCollegesForJobTitle(data) {
    return Service.post(HttpRoutes.getTopCollegesForTitle, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  fetchTopCollegesForMajor(data) {
    return Service.post(HttpRoutes.getTopCollegesForMajor, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  fetchDiversityPieChartData(data) {
    return Service.post(HttpRoutes.getDiversityPieChartData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchMostCommonDegreesPieChartData(data) {
    return Service.post(HttpRoutes.getMostCommonDegreesPieChartData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchGenderRatioBarChartData(data) {
    return Service.post(HttpRoutes.getGenderRatioBarChartData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchTitleAgeBreakdownData(data) {
    return Service.post(HttpRoutes.getTitleAgeBreakdownData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchTitleDurationsData(data) {
    return Service.post(HttpRoutes.getTitleDurationData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchTitleCompanySizesData(data) {
    return Service.post(HttpRoutes.getTitleCompanySizesData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchTitleCompanyTypesData(data) {
    return Service.post(HttpRoutes.getTitleCompanyTypesData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchTitleIndustriesData(data) {
    return Service.post(HttpRoutes.getTitleIndustriesData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchLgbtRatioData(data) {
    return Service.post(HttpRoutes.getLgbtRatioData, data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

  fetchRecentSalaries(data) {
    return Service.post(HttpRoutes.fetchJobTitleRecentSalaries, data)
      .then((response) => Promise.resolve(_get(response, 'data.salaryData', [])))
      .catch((error) => Promise.reject(error));
  },

  fetchDemographicAdjustmentData(data) {
    return Service.post(HttpRoutes.getDemographicAdjustmentData, data)
      .then((response) => Promise.resolve(_get(response, 'data', {})))
      .catch((error) => Promise.reject(error));
  },

  fetchCompanyDemographicAdjustmentData(data) {
    return Service.post(HttpRoutes.getCompanyDemographicAdjustmentData, data)
      .then((response) => Promise.resolve(_get(response, 'data', {})))
      .catch((error) => Promise.reject(error));
  },

  getCollegeExtendedData: (data) =>
    Service.post(HttpRoutes.getCollegeExtendedData, data)
      .then((data) => Promise.resolve(data))
      .catch((error) => Promise.reject(error)),

  getTitleSalaryOnlyStatesMapFileUrl: (title = '') => {
    const encodedTitle = removeSpecialCharacter(title);
    return `${format(HttpRoutes.getSalaryOnlyStatesMapForTitle, { encodedTitle })}.svgz`;
  },

  async getTitlesIndexes(titles) {
    const payload = {
      titles,
    };

    try {
      const { data } = await Service.post(HttpRoutes.getTitlesIndexes, payload);

      return data;
    } catch (err) {
      return err;
    }
  },
};

export default CommonService;
